import React from "react";
import { Paper, Table, TableBody, TableCell, TableContainer, TableRow } from "@material-ui/core";
import { Table as TablePDF } from "@david.kucsai/react-pdf-table/lib/Table";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";

export default function ViewSimpleReport(props) {
  const getPdfView = () => {
    return (
      <TablePDF data={props.rows}>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r[0]} />
          <DataTableCell weighting={0.3} getContent={(r) => r[1]} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r[2]} />
        </TableBodyPDF>
      </TablePDF>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {props.rows.map((row, i) => {
            return (
              <TableRow key={i}>
                <TableCell>{row[0]}</TableCell>
                <TableCell align={"right"}>{row[1]}</TableCell>
                <TableCell align={"right"}>{row[2]}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
